module.exports = __webpack_public_path__ + "img/front-light.8f20dbfb.png";